import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function MetaTags() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refCode = searchParams.get('ref');
  
  // Base URL - update this to your actual domain
  const baseUrl = 'https://sisrevolution.com';
  const logoUrl = `${baseUrl}/logo.jpg`;
  
  // Default description
  const defaultDescription = "Schools' Information System (SIS) Revolution is a comprehensive school database management system specially built to digitize the activities of schools. Manage students, staff, fees, exams, and more with our all-in-one solution.";
  
  const teacherPolicyDescription =
    "Privacy and policy for the SIS Revolution Teachers app: what data is collected, how it is used and shared, retention, security, your rights, third-party SDKs, and acceptable use. Align with Google Play Data safety.";

  const applyDescription =
    "Apply for school admission online with SIS Revolution. Parents and guardians can register students, pay admission fees securely, and track application status.";

  // Title with referral code if present
  let title = 'SIS Revolution - School Management System';
  if (refCode) {
    title = `Join SIS Revolution - Referred by ${refCode}`;
  } else if (location.pathname === '/teacherpolicy') {
    title = 'Teachers App — Privacy & Policy | SIS Revolution';
  } else if (location.pathname === '/apply' || location.pathname.startsWith('/apply/')) {
    title = 'Apply for Admission | SIS Revolution';
  }

  // Description with referral context or route-specific meta
  let description = defaultDescription;
  if (refCode) {
    description = `${defaultDescription} Join using referral code: ${refCode}`;
  } else if (location.pathname === '/teacherpolicy') {
    description = teacherPolicyDescription;
  } else if (location.pathname === '/apply' || location.pathname.startsWith('/apply/')) {
    description = applyDescription;
  }
  
  // Current page URL
  const currentUrl = `${baseUrl}${location.pathname}${location.search}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={logoUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="SIS Revolution" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={logoUrl} />

      {/* WhatsApp */}
      <meta property="og:image:type" content="image/jpeg" />
    </Helmet>
  );
}

export default MetaTags;

